export {
    default as image
} from "./image.glsl.js";

export {
    default as buffer
} from "./shader.glsl.js";
